import { buildModule } from '../utils';

import lazy from './lazy';

export default buildModule()
	.withSubmodules({
		lazy,
	});
